import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-resolution-base',
    templateUrl: './resolution-base.component.html',
    styleUrls: ['./resolution-base.component.scss'],
    standalone: false // NOSONAR
})
export class ResolutionBaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
